<template>
  <div class="layout-body">
    <v-bread :breadList="breadList" class="custom-bread">
      <div slot="v-right">
      </div>
    </v-bread>

    <div class="layout-content case-detail">
      <div class="el-menu-vertical-demo">
        <el-menu
          style="border: solid 1px #e6e6e6;border-radius: 4px"
          v-if="menuList && menuList.length > 0"
          :router="true"
          :unique-opened="false"
          :default-active="'/'"
          :default-openeds="[`/course-list/${menuList[0].id}`]"
        >
          <template v-for="item in menuList" >
            <el-menu-item :index="`/course-list/${item.id}`" v-if="!item.child || item.child.length === 0" :key="item.id">
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
            <el-submenu :index="`/course-list/${item.id}`" v-if="item.child && item.child.length > 0" :key="item.child.id">
              <template slot="title">
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item v-for="subItem in item.child" :key="subItem.id" :index="`/course-list/${item.id}/${subItem.id}`">
                {{ subItem.name }}
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>

        <div style="background: #ffffff;margin-top: 10px;padding: 10px;border: solid 1px #e6e6e6;border-radius: 4px">
          <div style="height: 30px;line-height: 30px;margin-left: 10px">
            联系我们
          </div>
          <div class="clearfix">
            <div style="float: left;width: 100px;">
              <img src="../../assets/images/qr-code2.jpeg" width="100" style="float: left;">
              <img src="../../assets/images/qr-code3.jpeg" width="100" style="float: left;">
              <img src="../../assets/images/qr-code4.jpeg" width="100" style="float: left;">

            </div>
            <div style="font-size: 12px;line-height: 24px;float: right;margin-left: 10px;width: 108px">
              <p style="font-size: 12px;line-height: 24px;">24小时售后电话</p>
              <p style="color: #0072BE;font-weight: bold"><i class="el-icon-phone-outline"></i>18820108551</p>
              <p style="color: #0072BE;font-weight: bold"><i class="el-icon-phone-outline"></i>18820108552</p>
              <p style="color: #0072BE;font-weight: bold"><i class="el-icon-phone-outline"></i>18819166707</p>
              <p style="margin-top: 8px;color: #0072BE;">
                <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=3469724070&site=qq&menu=yes">
                  <img border="0" src="../../assets/images/QQ.png" style="height: 15px;line-height: 24px;margin-bottom:-3px;" title="点击这里给我发消息"/>
                  2466315727
                </a>
              </p>
              <p style="margin-top: 0px;">
                <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=3469724070&site=qq&menu=yes">
                  <img border="0" src="../../assets/images/QQ.png" style="height: 15px;line-height: 24px;margin-bottom:-3px;" title="点击这里给我发消息"/>
                  3469724070
                </a>
              </p>
            </div>
          </div>
        </div>

        <div style="background: #ffffff;margin-top: 10px;padding: 10px;border: solid 1px #e6e6e6;border-radius: 4px">
          <div style="height: 30px;line-height: 30px;margin-left: 10px">
            移动商城
          </div>
          <div class="clearfix">
            <img src="../../assets/images/qr-code1.jpeg" width="100" style="float: left;margin-left: 3px;">
            <div style="font-size: 12px;line-height: 24px;float: left;margin-left: 15px">
              扫码关注公众号<br/>
              &lt;-进入移动商城
              <!--<p style="color: #0072BE;font-weight: bold"><i class="el-icon-phone-outline"></i>18820108551</p>
              <p style="color: #0072BE;font-weight: bold"><i class="el-icon-phone-outline"></i>18820108552</p>
              <p style="color: #0072BE;font-weight: bold"><i class="el-icon-phone-outline"></i>18819166707</p>-->
            </div>
          </div>
        </div>
      </div>

      <el-card class="box-card" shadow="never">
        <p class="title">
          {{ caseDetail.title }}
          <!--中国人民大学本科招生章程（2019年实行）-->
        </p>
        <p class="sub-tit">
          时间：{{ caseDetail.time }}
          <!--中国人民大学本科招生章程（2019年实行）-->
        </p>
        <el-divider></el-divider>
        <div class="content ql-editor" v-html="caseDetail.content"></div>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="12">上一篇：
            <template v-if="prevNextCaseDetail.previous">
              <router-link :to="`/case-detail/${prevNextCaseDetail.previous.id}`">
                {{ prevNextCaseDetail.previous.title }}
              </router-link>
            </template>
            <template v-else>无</template>
          </el-col>
          <el-col :span="12" align="right">下一篇：
            <template v-if="prevNextCaseDetail.next">
              <router-link :to="`/case-detail/${prevNextCaseDetail.next.id}`">
                {{ prevNextCaseDetail.next.title }}
              </router-link>
            </template>
            <template v-else>无</template>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import CourseApi from 'Api/courseApi';
import CaseApi from 'Api/caseApi';

export default {
  data() {
    return {
      breadList: [
        { name: '网站首页', url: '/' },
        { name: '应用案例列表', url: '/case-list' },
        { name: '应用案例详情', url: '' },
      ],
      caseId: this.$route.params.id || '',
      caseDetail: {
        content: '',
        caseSnapshot: {},
        commodityList: [],
      },
      prevNextCaseDetail: {},
      menuList: [],
    };
  },

  created() {
    this.getCaseDetail();
    this.getPrevNextCase();
    this.getMenuList();
  },

  mounted() {
  },

  watch: {
    $route() {
      this.$router.go(0);
    },
  },

  computed: {
  },

  methods: {
    getMenuList() {
      CourseApi.getMenuList(null, (response) => {
        this.menuList = response.data;
      });
    },

    getCaseDetail() {
      CaseApi.getCaseDetail(this.caseId, (response) => {
        this.caseDetail = response.data;
      });
    },

    getPrevNextCase() {
      CaseApi.getPrevNextCase(this.caseId, (response) => {
        this.prevNextCaseDetail = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .case-detail {
    background: #ffffff;
    padding: 0px;
    .title {
      text-align: center;
      font-size: 24px;
      margin: 30px 0 20px 0;
      color: #333333;
    }
    .sub-tit {
      text-align: center;
      font-size: 14px;
      color: #666666;
      margin-right: 50px;
    }
    .el-divider__text {
      background: transparent;
    }
    .el-menu-vertical-demo {
      float: left;
      width: 240px;
      margin-right: 20px;
    }
  }
</style>
<style lang="scss">
  .case-detail {
    .attr-item {
      margin-bottom: 20px;
      .label {
        display: inline-block;
        width: 100px;
        color: #666666;
      }
    }
    .content {
      img {
        max-width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/case/case-detail.vue